import instance from "./axios";
import baseUrl from "@/env";

export async function getBookCourseList(catalogID) {
  const query = catalogID ? `?catalogID=${encodeURIComponent(catalogID)}` : "";
  const res = await instance.get(
    `${baseUrl}/app/book/public/course/list${query}`
  );
  return res.data;
}

export async function getBookTextbookByCourse(courseId) {
  const res = await instance.get(
    `${baseUrl}/app/book/public/textbook/by-course/${courseId}`
  );
  return res.data;
}

export async function getBookKnowledgeByTextbook(textbookId) {
  const res = await instance.get(
    `${baseUrl}/app/book/public/knowledge/by-textbook/${textbookId}`
  );
  return res.data;
}

export async function openBookTextbook(textbookId, activationCode) {
  const payload = { textbookId };
  if (activationCode) {
    payload.activationCode = activationCode;
  }
  const res = await instance.post(
    `${baseUrl}/app/book/open/textbook/open`,
    payload
  );
  return res.data;
}

export async function checkBookTextbook(textbookId) {
  const res = await instance.get(
    `${baseUrl}/app/book/open/check?textbookId=${textbookId}`
  );
  return res.data;
}
